import { isDefined } from '@app/utils/is';

import { TextEllipsis } from '../TextEllipsis';

interface Props {
  title?: string;
}

export const SeparatorItem = ({ title }: Props) => {
  const hasTitle = isDefined(title);

  return (
    <div className="flex w-full items-center gap-2">
      {hasTitle && <TextEllipsis className="heading-4">{title}</TextEllipsis>}
      <div className="h-px grow bg-neutral-90" />
    </div>
  );
};
